import { Component, OnInit,Input } from '@angular/core';
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/tree';
import { SelectItem, TreeNode } from 'primeng/api';
import { ReportMetadata, ReportSchedule, ReportState, ReportYear, ReportCategory} from '../models/report.model';
import { ReportService } from '../services/report.service';
import { Observable } from 'rxjs';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { environment } from '../../environments/environment';
import { ActivatedRoute} from '@angular/router';
// import { ReportdashboardService } from '../services/reportdashboard.service';
import { ReportScheduleService } from '../services/reportschedule.service';
import { NotifierService } from 'angular-notifier';
import { Location, PostLocationsModel } from '../models/user.model';
import { ReportdashboardService } from '../services/reportdashboard.service';
//import { forEach } from '@angular/router/src/utils/collection';
import { ok } from 'assert';
import { TreeTable } from 'primeng/TreeTable';



@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
reportScheduleData: ReportSchedule[];
reportMetadataData: ReportMetadata[];
reportState: ReportState[];
reportCategory: ReportCategory[];
parentCategory: string;
reportCategories: TreeNode[];
fileTree: TreeNode[];
fileNode: TreeNode;
requiredReportcount : number;
voluntaryReportcount : number;
cols : any[];

region: PostLocationsModel[];
ReportYears: ReportYear[];

@Input()
ReportYear: ReportYear;

constructor(
  // private reportDashboardService: ReportdashboardService,
  private lookUpService: LookupService,
  private reportService: ReportService,
  private reportScheduleService: ReportScheduleService,
  private reportDashboardService: ReportdashboardService,
  private notifier: NotifierService){}

    ngOnInit() {
      this.ReportYear = new ReportYear();
      this.ReportYear.year = new Date().getFullYear();

      var Years = new Array<ReportYear>();
      Years = [
        { id: 1, year: this.ReportYear.year },
        { id: 2, year: this.ReportYear.year - 1 },
        { id: 3, year: this.ReportYear.year - 2 }
      ];
      this.ReportYears = Years;

  this.mapReportSchedule(this.ReportYear);
//   this.onYearSelected(this.ReportYear.year);
  // console.log("YEAR==============" + this.ReportYear.year);
    }

    onYearSelected(value) {

    //console.log("YEAR==============" + value);
      this.mapReportSchedule(value);
    }

    getReportCount(id: number)
    {
      for (let i = 0; i < this.reportMetadataData.length; i++) {
        if(this.reportMetadataData[i].categoryId == id){
          this.requiredReportcount +1;
        }
      }
      return this.requiredReportcount;
    }

mapReportSchedule(reportingYear: ReportYear) {
      this.reportService.getSummaryData(reportingYear.year).subscribe((data) => {

        // this.lookUpService.getReportCategoryHierarchy$().subscribe((data)=>{
            //console.log(Array.of(data));
        //console.log("DATA ====================" + JSON.stringify(Array.of(data)));

            this.reportCategories = Array.of(data);


      });
      //console.log("Count====================" + JSON.stringify(this.reportMetadataData));
    }

    getUniqueValues(filterItem: any[]): SelectItem[] {
      var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      return returnArray;
    }
}



